///
/// EarthBrowser
///
/// Migration: v24 -> v25
/// Adds radar visibility setting (persisted)
///
/// Created by Matt Giger on 1/29/2026
/// Copyright (c) 2026 Geodata Labs
///

interface StateV24 {
	earthbrowser?: {
		radarVisible?: boolean
	}
}

export function migrateV24toV25(state: unknown): unknown {
	const s = state as StateV24
	// Add radarVisible with default false to the earthbrowser slice
	if (s.earthbrowser && s.earthbrowser.radarVisible === undefined) {
		s.earthbrowser.radarVisible = false
	}

	return state
}
